import BookType from "types/BookType";
import classNames from "lib/classNames";
import CoverLink from "components/Cover/CoverLink";
import { BookGroupSizeType, BookListContextType } from "../types";
import { EditionSerializersEditionByline } from "types/serializers";

export default function BookGroupListItem({
  book,
  edition,
  context,
  index,
  size,
}: {
  book: BookType;
  edition?: EditionSerializersEditionByline;
  context: BookListContextType;
  index: number;
  size: BookGroupSizeType;
}) {
  const active = context.activeBook?.id === book.id;

  return (
    <div className={classNames(
        index > 8 ? "block md:hidden lg:block" : "",
        index > 10 ? "lg:hidden" : "",
        index > 12 ? "hidden" : ""
    )}>
      <div className="relative group inline-block">
        <CoverLink
          book={book}
          edition={edition}
          size={size === "lg" ? "md" : "sm"}
          variant={active ? "accent" : "none"}
          settings={{
            tooltip: true,
            showStatus: true,
            details: true,
            referrerId: context.referrerId,
          }}
        />
      </div>
    </div>
  );
}
